import React from 'react'
import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'

const DropdownMenu = ({button, userName, menuItems, buttonClasses}) => {
  return (
    <div className="text-right relative">
      <Menu as="div" className="relative inline-block text-right">
        <div className="flex flex-row items-center">
          <Menu.Button className={buttonClasses}>
            {button}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 w-56 mt-2 z-20 origin-top-right bg-white border border-secondary border-opacity-20 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <p className='lg:hidden text-left p-[10px] bg-gray-100 rounded'>{userName}</p>
            
            <div className="px-1 py-1 ">
            {menuItems.map((item, itemIndex) => (<Menu.Item key={itemIndex}>
                {({ active }) => (
                  <button
                  onClick={()=>{item.action()}}
                    className={`font-sofia-pro text-sm text-secondary ${
                      active ? 'bg-gray-100' : 'text-opacity-80'
                    } group flex rounded-md items-center w-full px-2 py-2 text-sm hover:text-opacity-30`}
                  >
                        {/* <span className="mr-1">
                            <img src={item.icon} alt="icon" className="w-6"/> 
                        </span> */}
                    {item.icon &&
                        item.icon
                    }
                    {item.label}
                  </button>
                )}
              </Menu.Item>))}
            </div> 
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}


export default DropdownMenu

